export default "__VITE_PUBLIC_ASSET__2d5a066f__"